module.exports = __webpack_public_path__ + "site/img/team_member_sign_Abby.296704c5.png";